import { Base } from "./Base";

const body = document.body;

export class HeroDoubleV2 extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.resizeHandler = this.resize.bind(this);
    window.addEventListener("resize", this.resizeHandler);
    this.resizeHandler();
  }

  resize(e) {
    // disable "not-full-height-hero" for now
    // this.element.style.setProperty("--hero-double-v2-vh", `${Math.round(window.innerHeight)*0.9}px`);
    this.element.style.setProperty("--hero-double-v2-vh", `100svh`);
  }

  cleanup() {
    window.removeEventListener("resize", this.resizeHandler);
  }
}
